import React from "react";
import { Navigate } from "react-router";
import { NavLink } from "react-router-dom";
import Base from "./Base";
import PracticalText from "./PracticalText";

export default class PracticalTexts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.companyResumeId,
            caller: props.Caller,
            onSelect: props.OnSelect,
            controllerName: "practicaltext",
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            filters: {
                type: props.Type,
            },
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;

        this.state.filters.type = props.Type;
        this.refreshData();
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalText
                    Caller={this}
                    Type={this.state.filters.type}
                />
            ),
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalText
                    Caller={this}
                    Id={id}
                    Type={this.state.filters.type}
                />
            ),
        });
    }
    select(e) {
        this.state.caller[this.state.onSelect](e);
        this.closeMe();
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input
                                            type="text"
                                            defaultValue={this.state.filters.phrase}
                                            onChange={(e) =>
                                                (this.state.filters.phrase = e.target.value)
                                            }
                                            placeholder="متن مورد نظر"
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>هیچ متنی یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">متن</span></div>
                                    <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                    {record.text}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="nk-tb-col text-end">
                                            <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                <em className="icon ni ni-cross-fill-c"></em>
                                            </a>
                                            <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                <em className="icon ni ni-pen"></em>
                                            </a>
                                            {!this.isNull(this.state.onSelect) && <a className="hand text-primary mx-1" onClick={e => this.select(record)} title="انتخاب">
                                                <em className="icon ni ni-list-check"></em>
                                            </a>}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                فهرست متنهای پرکاربرد
                                <small>({this.money(this.state.data.recordsCount)})</small>
                            </h4>
                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد متن جدید</span></a>
                        </div>
                        <div className="modal-body">
                            <div className="nk-content-body">
                                {this.renderView()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}